"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameResponseAllOfToJSON = exports.OWGameResponseAllOfFromJSONTyped = exports.OWGameResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OWGameResponseAllOfFromJSON(json) {
    return OWGameResponseAllOfFromJSONTyped(json, false);
}
exports.OWGameResponseAllOfFromJSON = OWGameResponseAllOfFromJSON;
function OWGameResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasUserStats': !(0, runtime_1.exists)(json, 'hasUserStats') ? undefined : json['hasUserStats'],
        'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'],
        'slug': !(0, runtime_1.exists)(json, 'slug') ? undefined : json['slug'],
        'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'seo': !(0, runtime_1.exists)(json, 'seo') ? undefined : (0, _1.OWGameSEOFromJSON)(json['seo']),
        'steamMatch': !(0, runtime_1.exists)(json, 'steamMatch') ? undefined : (0, _1.OWGameSteamMatchFromJSON)(json['steamMatch']),
        'steamData': !(0, runtime_1.exists)(json, 'steamData') ? undefined : (0, _1.OWGameSteamDataFromJSON)(json['steamData']),
        'steamLogoUrl': !(0, runtime_1.exists)(json, 'steamLogoUrl') ? undefined : json['steamLogoUrl'],
        'steamDataLastRefreshed': !(0, runtime_1.exists)(json, 'steamDataLastRefreshed') ? undefined : (new Date(json['steamDataLastRefreshed'])),
        'steamNews': !(0, runtime_1.exists)(json, 'steamNews') ? undefined : json['steamNews'],
    };
}
exports.OWGameResponseAllOfFromJSONTyped = OWGameResponseAllOfFromJSONTyped;
function OWGameResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasUserStats': value.hasUserStats,
        'steamAppId': value.steamAppId,
        'slug': value.slug,
        'timeTrackedGame': value.timeTrackedGame,
        'seo': (0, _1.OWGameSEOToJSON)(value.seo),
        'steamMatch': (0, _1.OWGameSteamMatchToJSON)(value.steamMatch),
        'steamData': (0, _1.OWGameSteamDataToJSON)(value.steamData),
        'steamLogoUrl': value.steamLogoUrl,
        'steamDataLastRefreshed': value.steamDataLastRefreshed === undefined ? undefined : (value.steamDataLastRefreshed.toISOString()),
        'steamNews': value.steamNews,
    };
}
exports.OWGameResponseAllOfToJSON = OWGameResponseAllOfToJSON;
